// var filtersMobileButton = document.querySelector(".filters-mobile-button");
// filtersMobileButton?.addEventListener("click", (e) => {
//   var filterButton = e.target;
//   if (filterButton) {
//     var filterMobile = filterButton.closest(".filters-mobile-wrapper").querySelector(".filters-mobile");
//   }
//   console.log(filterMobile);
//   if (filterMobile) {
//     filterMobile.classList.toggle("d-none");
//   }
// });